export const narrowInstance = <T>(value: unknown, ctor: abstract new (...args: never[]) => T): T | undefined => (value instanceof ctor ? value : undefined)
